import React from 'react';
import { Link } from 'react-router-dom';

const ExploreSection = () => {
  return (
    <div className="flex flex-col min-w-[275px] gap-6 border-l border-white pl-6">
      {/* Title */}
      <h2 className="font-['Axiforma'] text-2xl font-black text-white">
        Explore
      </h2>

      {/* Links container */}
      <div className="flex flex-col gap-4">
        <Link
          to="/about"
          className="text-[#f2f2f2] text-base font-normal tracking-[0.8px] hover:text-gray-300 transition-colors"
        >
          About Us
        </Link>
        <Link
          to="/contact-us"
          className="text-white text-base font-normal hover:text-gray-300 transition-colors"
        >
          Contact Us
        </Link>
        <Link
          to="/nkenneai-api"
          className="text-white text-base font-normal hover:text-gray-300 transition-colors"
        >
          NKENNE API
        </Link>
        <Link
          to="/african-language-imp"
          className="text-[#f2f2f2] text-base font-normal tracking-[0.8px] hover:text-gray-300 transition-colors"
        >
          Why Languages Are Important
        </Link>
        <Link
          to="/use-cases-and-solutions"
          className="text-[#f2f2f2] text-base font-normal tracking-[0.8px] hover:text-gray-300 transition-colors"
        >
          Use Cases And Solutions
        </Link>
        <Link
          to="/services"
          className="text-[#f2f2f2] text-base font-normal tracking-[0.8px] hover:text-gray-300 transition-colors"
        >
          Our Services
        </Link>
      </div>
    </div>
  );
};

export default ExploreSection;
